import { useEnvState } from '../../context/env';
import { useAuthState } from '../../context/auth';
import { topicsAPI } from '../../context/topics';
import { clone } from '../utils/helpers';
const useTopicsManager = () => {
  const envState = useEnvState();
  const authState = useAuthState();
  const getDigestInfo = async topics => {
    const digestResponse = await topicsAPI.getTopicsDigest(envState.base_url, authState.api_key, topics.map(topic => topic.id));
    if (digestResponse) {
      topics.forEach(topic => {
        let thisTopicDigest = digestResponse[String(topic.id)];
        topic.original_poster = thisTopicDigest.original_poster;
        topic.first = thisTopicDigest.first;
        topic.recent = thisTopicDigest.recent;
      });
    }
    return topics;
  };
  const updateTopicPostContents = (id, post, topicsList, setTopicsList) => {
    const updatedTopicId = id;
    const list = clone(topicsList);
    for (let i = 0; i < list.length; i++) {
      if (updatedTopicId === list[i].id) {
        const now = new Date();
        list[i].last_posted_at = now.toISOString();
        list[i].first.post.cooked = post.cooked;
        list[i].first.post.raw = post.raw;
        setTopicsList(list);
        break;
      }
    }
  };
  return {
    getDigestInfo,
    updateTopicPostContents
  };
};
export { useTopicsManager };
//# sourceMappingURL=useTopicsManager.js.map